"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var regionTypeData = (_a = {},
    _a[0 /* Table */] = {
        skipTags: ['TABLE'],
        outerSelector: 'table',
        innerSelector: 'td,th',
    },
    _a);
/**
 * @internal
 */
exports.default = regionTypeData;
//# sourceMappingURL=regionTypeData.js.map